export default __webpack_public_path__ + "static/media/shool_clubs.e98ff2b4.jpg";